/**
 * GarenPainter — Single Responsibility: dibujar el modelo 2D de Garen.
 * Contrato: paint(ctx, pos, radius, entity) → void
 * NO importa Three.js, DOM, ni lógica de negocio.
 */
export const GarenPainter = {
  /**
   * @param {CanvasRenderingContext2D} ctx
   * @param {{ x: number, y: number }} pos
   * @param {number} radius
   * @param {object} _entity  (reservado para estado futuro como skins, etc.)
   */
  paint(ctx, pos, radius, _entity) {
    // Demacian Blue Cape
    ctx.beginPath();
    ctx.moveTo(-radius * 0.8, -radius * 0.6);
    ctx.lineTo(-radius * 1.3, 0);
    ctx.lineTo(-radius * 0.8, radius * 0.6);
    ctx.fillStyle = '#0f2b5c';
    ctx.fill();

    // Golden Shoulder Pauldrons
    ctx.beginPath();
    ctx.arc(0, -radius * 0.9, radius * 0.45, 0, Math.PI * 2);
    ctx.arc(0,  radius * 0.9, radius * 0.45, 0, Math.PI * 2);
    ctx.fillStyle = '#ffc800';
    ctx.fill();

    // Greatsword held forward
    ctx.beginPath();
    ctx.rect(radius * 0.2, -4, radius * 1.2, 8);
    ctx.fillStyle = '#e2e8f0';
    ctx.fill();
    ctx.strokeStyle = '#334155';
    ctx.lineWidth = 1.5;
    ctx.stroke();
  }
};
